import React from 'react';
import './HomeNav.css';
import { useLocation, useNavigate } from 'react-router-dom';

export const HomeNav = ({ menus }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = React.useState('');

    const handleTabClick = (path) => {
        setActiveTab(path);
        navigate(path);
    };

    React.useEffect(() => {
        const currentPath = location.pathname;
        const activeMenu = menus.find((menu) => currentPath.includes(menu.path));
        if (activeMenu) {
            setActiveTab(activeMenu.path);
        }
    }
    , [location.pathname, menus]);

    return (
        <div className="tabs">
            {menus.map((menu, index) => (
                <div
                    key={index}
                    className={`tab ${activeTab === menu.path ? 'active' : ''}`}
                    onClick={() => handleTabClick(menu.path)}
                >
                    {menu.title}
                </div>
            ))}
        </div>
    );
};
